import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { round } from 'lodash';

export const availableGoodQuantityValidator =
  (availableQuantity: number): ValidatorFn =>
  (control: AbstractControl<number | null>): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    if (availableQuantity < 0) {
      return { availableGoodQuantity: round(Math.abs(availableQuantity), 3) };
    }
    return null;
  };
